/**
 * ResourceTypeInfo.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ResourceTypeInfo.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 */
export const ResourceTypeInfo = {
    "NA"  : 'Unknown',
    "res" : "Resource",
    "bmp" : 'Bitmap Image',
    "mve" : 'Infinity Engine Video',
    "tga" : 'TGA Image',
    "wav" : 'Wave File',
    "plt" : 'Packed Layer Texture',
    "ini" : 'INI Config File',
    "bmu" : 'MP3 with Extra Header',
    "mpg" : 'MPEG Video',
    "txt" : 'Text File',
    "wma" : 'Windows Media Audio',
    "wmv" : 'Windows Media Video',
    "xmv" : 'Xbox Video',
    "plh" : 'Placeable Header',
    "tex" : 'Texture',
    "mdl" : 'Binary Model',
    "thg" : 'THG File',
    "fnt" : 'Font',
    "lua" : 'LUA Script Source',
    "slt" : 'SLT File',
    "nss" : 'Script Source',
    "ncs" : 'Script Compiled',
    "are" : 'Module Area',
    "set" : 'SET',
    "ifo" : 'Module Info',
    "bic" : 'Character File',
    "wok" : 'Walkmesh: Model',
    "2da" : '2D Array',
    "tlk" : 'Talk Table',
    "txi" : 'Texture Info',
    "git" : 'Dynamic Area Info',
    "bti" : 'Template: Item (BioWare)',
    "uti" : 'Template: Item',
    "btc" : 'Template: Creature (BioWare)',
    "utc" : 'Template: Creature',
    "dlg" : 'Conversation File',
    "itp" : 'Template: Pallet',
    "btt" : 'Template: Trigger (BioWare)',
    "utt" : 'Template: Trigger',
    "dds" : 'DDS Image',
    "bts" : 'Template: Sound (BioWare)',
    "uts" : 'Template: Sound',
    "ltr" : 'Letter File',
    "gff" : 'Generic File Format',
    "fac" : 'Template: Faction',
    "bte" : 'Template: Encounter (BioWare)',
    "ute" : 'Template: Encounter',
    "btd" : 'Template: Door (BioWare)',
    "utd" : 'Template: Door',
    "btp" : 'Template: Placeable (BioWare)',
    "utp" : 'Template: Placeable',
    "dft" : 'Default Values',
    "dtf" : 'Default Value File',
    "gic" : 'Game Comment',
    "gui" : 'GUI File',
    "css" : 'Conditional Source Script',
    "ccs" : 'Conditional Compiled Script',
    "btm" : 'Template: Merchant (BioWare)',
    "utm" : 'Template: Merchant',
    "dwk" : 'Walkmesh: Door',
    "pwk" : 'Walkmesh: Placeable',
    "btg" : 'Template: Random Item Generator (BioWare)',
    "utg" : 'Template: Random Item Generator',
    "jrl" : 'Journal',
    "sav" : 'Save',
    "utw" : 'Template: Waypoint',
    "4pc" : 'Custom 16-bit RGBA Texture',
    "ssf" : 'SoundSet',
    "hak" : 'HakPack',
    "nwm" : 'NWN Mod Archive',
    "bik" : 'Bink Video',
    "ndb" : 'Script Debugger File',
    "ptm" : 'Plot Manager',
    "ptt" : 'Plot Wizard Template',
    "ncm" : 'NCM File',
    "mfx" : 'MFX File',
    "mat" : 'Material',
    "mdb" : 'BioWare Model',
    "say" : 'SAY File',
    "ttf" : 'TrueType Font',
    "ttc" : 'TrueType Collection',
    "cut" : 'Cutscene',
    "ka" : 'Karma XML',
    "jpg" : 'JPEG Image',
    "ico" : 'Windows Icon',
    "ogg" : 'Ogg Vorbis Audio',
    "spt" : 'SpeedTree Data',
    "spw" : 'SPW File',
    "wfx" : 'Woot Effect Class XML',
    "ugm" : 'UGM File',
    "qdb" : 'Quest Database',
    "qst" : 'Quest',
    "npc" : 'NPC File',
    "spn" : 'SPN File',
    "utx" : 'UTX File',
    "mmd" : 'MMD File',
    "smm" : 'SMM File',
    "uta" : 'UTA File',
    "mde" : 'MDE File',
    "mdv" : 'MDV File',
    "mda" : 'MDA File',
    "mba" : 'MBA File',
    "oct" : 'OCT File',
    "bfx" : 'BFX File',
    "pdb" : 'PDB File',
    "thewitchersave" : 'The Witcher Save',
    "pvs" : 'PVS File',
    "cfx" : 'CFX File',
    "luc" : 'LUA Bytecode',
    "prb" : 'PRB File',
    "cam" : 'Campaign Information',
    "vds" : 'VDS File',
    "bin" : 'Binary File',
    "wob" : 'WOB File',
    "api" : 'API File',
    "properties" : 'Properties File',
    "png" : 'PNG Image',

    "lyt" : 'Layout',
    "vis" : 'Visible Rooms Layout',
    "rim" : 'RIM Archive',
    "pth" : 'AI Path',
    "lip" : 'Lip Sync',
    "bwm" : 'BWM File',
    "txb" : 'TXB Texture',
    "tpc" : 'TPC Texture',
    "mdx" : 'Binary Model-X',
    "rsv" : 'RSV File',
    "sig" : 'SIG File',
    "mab" : 'Material Binary',
    "qst2" : 'Quest 2',
    "sto" : 'STO File',
    "hex" : 'Hex Grid File',
    "mdx2" : 'Binary Model-X 2',
    "txb2" : 'TXB Texture 2',
    "fsm" : 'Finite State Machine',
    "art" : 'Area Environment Settings',
    "amp" : 'Brightening Control',
    "cwa" : 'Crowd Attributes',
    "bip" : 'Binary LIP Data',

    "mdb2" : 'BioWare Model 2',
    "mda2" : 'MDA File 2',
    "spt2" : 'SpeedTree Data 2',
    "gr2" : 'GR2 File',
    "fxa" : 'FXA File',
    "fxe" : 'FXE File',
    "jpg2" : 'JPEG Image 2',
    "pwc" : 'PWC File',

    "exe" : 'Windows PE EXE',
    "dbf" : 'xBase Database',
    "cdx" : 'FoxPro Database Index',
    "fpt" : 'FoxPro Database Memo',

    "zip" : 'ZIP Archive',
    "fxm" : 'FaceFX Actor',
    "fxs" : 'FaceFX Metadata',
    "xml" : 'XML File',
    "wlk" : 'Walk Mesh',
    "utr" : 'Template: Tree (User)',
    "sef" : 'Special Effect File',
    "pfx" : 'Particle Effect',
    "tfx" : 'Trail Effect',
    "ifx" : 'IFX File',
    "lfx" : 'Line Effect',
    "bbx" : 'Billboard Effect',
    "pfb" : 'Prefab Blueprint',
    "upe" : 'UPE File',
    "usc" : 'USC File',
    "ult" : 'Template: Light (User)',
    "fx" : 'FX File',
    "max" : 'MAX File',
    "doc" : 'DOC File',
    "scc" : 'SCC File',
    "wmp" : 'World Map',
    "osc" : 'OSC File',
    "trn" : 'TRN File',
    "uen" : 'UEN File',
    "ros" : 'ROS File',
    "rst" : 'RST File',
    "ptx" : 'PTX File',
    "ltx" : 'LTX File',
    "trx" : 'TRX File',

    "nds" : 'Nintendo DS ROM',
    "herf" : 'Hashed ERF',
    "dict" : 'HERF Dictionary',
    "small" : 'Nintendo LZSS Compressed',
    "cbgt" : 'CBGT File',
    "cdpth" : 'CDPTH File',
    "emit" : 'EMIT File',
    "itm" : 'Items 2DA',
    "nanr" : 'Nitro Animation Resource',
    "nbfp" : 'Nitro Basic File Palette',
    "nbfs" : 'Nitro Basic File Screen',
    "ncer" : 'Nitro Cell Resource',
    "ncgr" : 'Nitro Character Graphic Resource',
    "nclr" : 'Nitro Color',
    "nftr" : 'Nitro Font',
    "nsbca" : 'Model Animation',
    "nsbmd" : 'Nitro Model',
    "nsbta" : 'Texture Animation',
    "nsbtp" : 'Texture Part',
    "nsbtx" : 'Nitro Texture',
    "pal" : 'Palette',
    "raw" : 'Raw Image',
    "sadl" : 'SADL File',
    "sdat" : 'Sound Data',
    "smp" : 'SMP File',
    "spl" : 'Spells 2DA',
    "vx" : 'Actimagine Video',

    "anb" : 'Animation Blend',
    "ani" : 'Animation Sequence',
    "cns" : 'Client Script Source',
    "cur" : 'Windows Cursor',
    "evt" : 'Animation Event',
    "fdl" : 'FDL File',
    "fxo" : 'FXO File',
    "gad" : 'GOB Animation Data',
    "gda" : 'GFF 2DA Table',
    "gfx" : 'Scaleform GFx Animation',
    "ldf" : 'Language Definition',
    "lst" : 'Area List',
    "mal" : 'Material Library',
    "mao" : 'Material Object',
    "mmh" : 'Model Mesh Hierarchy',
    "mop" : 'MOP File',
    "mor" : 'Head Morph',
    "msh" : 'Mesh',
    "mtx" : 'MTX File',
    "ncc" : 'Compiled Client Script',
    "phy" : 'Physics Collision Info',
    "plo" : 'Plot Information',
    "stg" : 'Cutscene Stage',
    "tbi" : 'TBI File',
    "tnt" : 'Material Tint',
    "arl" : 'Area Layout',
    "fev" : 'FMOD Event',
    "fsb" : 'FMOD Sound Bank',
    "opf" : 'OPF File',
    "crf" : 'CRF File',
    "rimp" : 'RIMP File',
    "met" : 'Resource Meta Information',
    "meta" : 'Resource Meta Information',
    "fxr" : 'FaceFX Metadata',
    "fxt" : 'FaceFX Metadata',
    "cif" : 'Campaign Information File',
    "cub" : 'CUB File',
    "dlb" : 'DLB File',
    "nsc" : 'NWScript Client Source',

    "mov" : 'QuickTime/MPEG-4 Video',
    "curs" : 'Mac CURS Format',
    "pict" : 'Mac PICT Format',
    "rsrc" : 'Mac Resource Fork',
    "plist" : 'Mac Property List',

    "cre" : 'Creature GFF',
    "pso" : 'Pixel Shader',
    "vso" : 'Vertex Shader',
    "abc" : 'Font Character Descriptions',
    "sbm" : 'Font Character Bitmap',
    "pvd" : 'PVD File',
    "pla" : 'Placeable GFF',
    "trg" : 'Trigger GFF',
    "pk" : 'PK File',

    "als" : 'ALS File',
    "apl" : 'APL File',
    "assembly" : 'Assembly File',
    "bak" : 'Backup File',
    "bnk" : 'BNK File',
    "cl" : 'CL File',
    "cnv" : 'CNV File',
    "con" : 'CON File',
    "dat" : 'DAT File',
    "dx11" : 'DX11 File',
    "ids" : 'IDS File',
    "log" : 'LOG File',
    "map" : 'MAP File',
    "mml" : 'MML File',
    "mp3" : 'MP3 Audio',
    "pck" : 'PCK File',
    "rml" : 'RML File',
    "s" : 'S File',
    "sta" : 'STA File',
    "svr" : 'SVR File',
    "vlm" : 'VLM File',
    "wbd" : 'WBD File',
    "xbx" : 'XBX File',
    "xls" : 'XLS File',

    "bzf" : 'LZMA-compressed BIF',

    "adv" : 'Extra Adventure Module',

    "json" : 'JSON File',
    "tlk_expert" : 'Expert Talk Table',
    "tlk_mobile" : 'Mobile Talk Table',
    "tlk_touch" : 'Touch Talk Table',
    "otf" : 'OpenType Font',
    "par" : 'PAR File',

    "xwb" : 'XACT WaveBank',
    "xsb" : 'XACT SoundBank',

    "xds" : 'Xbox Texture',
    "wnd" : 'WND File',

    "xeositex" : 'Intermediate Texture',

    "wbm" : 'WebM Video',

    "1da" : '1D Array',
    "erf" : 'ERF Archive',
    "bif" : 'BIF Archive',
    "key" : 'BIF Archive KEY',

    getKeyByValue: function( value: any ) {
        for( let prop in this ) {
            if( this.hasOwnProperty( prop ) ) {
                 if( this[ prop ] === value )
                     return prop;
            }
        }
    }

}
